import { isBefore } from 'date-fns';
import { ApplicationStatus } from '../enums/application-status';
import { ApplicationDto } from '../interfaces/application-dto';
import { TeamPlayer } from 'modules/teams/domain/interfaces/team-player';
import { getNormalizedDate } from 'shared/utils/get-normalized-date';
import { AnnouncedTeamStatus } from '../enums/announced-team-status';

import { AnnouncedTeam } from '../interfaces/announced-team';
import { AnnouncedTeamsMap } from '../interfaces/announced-teams-map';
import { PlayerApplication } from '../interfaces/player-application';

export function mapAnnouncedChampionshipTeams(championshipId: number, applications: ApplicationDto[]) {
  const result: AnnouncedTeamsMap = {};

  applications.forEach((app) => {
    const teamId = app.team.id;
    const status = app.state;
    const createdAt = new Date(app.createdAt);

    if (!result[teamId]) {
      result[teamId] = {
        id: app.team.id,
        name: app.team.name,
        shortName: app.team.shortName,
        logo: app.team.emblem
          ? {
              id: app.team.emblem.id,
              url: app.team.emblem.externalUrl,
            }
          : undefined,
        createdAt: app.team.createdAt && getNormalizedDate(app.team.createdAt),
        status: AnnouncedTeamStatus.ANNOUNCED,
        applications: [],
        isNew: false,
      };
    }

    const announcedTeam = result[teamId];

    const playerApplication = {
      id: app.id,
      championshipId,
      teamId,
      status,
      createdAt: createdAt.toISOString(),
      position: app.position,
      number: app.number,
      player: {
        id: app.user.id,
        firstName: app.user.name,
        lastName: app.user.surname,
        middleName: app.user.middleName,
        birthDate: app.user.birthDate,
        logoUrl: app.user.photo?.externalUrl,
      },
    } as PlayerApplication;

    announcedTeam.applications.push(playerApplication);

    if (!announcedTeam.applicationDate || isBefore(createdAt, new Date(announcedTeam.applicationDate))) {
      announcedTeam.applicationDate = createdAt.toISOString();
    }
  });

  Object.values(result).forEach((team: AnnouncedTeam) => {
    // Новая логика определения статуса команды
    if (team.applications.length > 0) {
      const hasAcceptedApplications = team.applications.some((app) => app.status === ApplicationStatus.ACCEPTED);
      const allApplicationsDeclined = team.applications.every((app) => app.status === ApplicationStatus.DECLINED);
      const allApplicationsPending = team.applications.every((app) => app.status === ApplicationStatus.PENDING);

      if (allApplicationsDeclined) {
        team.status = AnnouncedTeamStatus.DECLINED;
      } else if (hasAcceptedApplications) {
        team.status = AnnouncedTeamStatus.ACCEPTED;
      } else if (allApplicationsPending) {
        team.status = AnnouncedTeamStatus.PENDING;
      } else {
        team.status = AnnouncedTeamStatus.ANNOUNCED;
      }
    }
  });
  return result;
}

export function mapPlayerToAnnounced(
  players: TeamPlayer[],
  props: { teamId: number; championshipId: number; teamCreatedAt?: string },
) {
  const { teamId, championshipId, teamCreatedAt = new Date().toISOString() } = props;

  return (players || []).map(
    (player) =>
      ({
        id: new Date().getTime(),
        championshipId,
        teamId: teamId,
        status: ApplicationStatus.PENDING,
        createdAt: teamCreatedAt,
        position: player.position,
        number: player.number,
        player: {
          id: player.userId,
          firstName: player.firstName,
          lastName: player.lastName,
          middleName: player.middleName,
          birthDate: player.birthDate,
          logoUrl: player.avatar,
          isReal: player.isReal,
        },
      }) as PlayerApplication,
  );
}
